export const program = {
  projectStatus: [{
    value: 0, label: '取消'}, {
    value: 1, label: '方案询价'}, {
    value: 2, label: '保司报价'}, {
    value: 3, label: '客户确认'}, {
    value: 4, label: '授权委托'}, {
    value: 5, label: '承保方案'}, {
    value: 6, label: '出单指令'}, {
    value: 7, label: '出单凭证'}, {
    value: 8, label: '共保协议'}, {
    value: 9, label: '费用结算'
  }]
}

export default {
  program
}



// WEBPACK FOOTER //
// ./src/data/program.js